import React from "react";
import HeroBanner from "./HeroBanner";
import TariffsSection from "./TariffsSection";
import SpeedTestSection from "./SpeedTestSection";
import CoverageSection from "./CoverageSection";
import AboutSection from "./AboutSection";
import ContactsSection from "./ContactsSection";
import virtualreality_animation from "../assets/animation/virtualreality-banner.json";

export default function LandingPage() {
  return (
    <div className="w-full flex flex-col">
      {/* 1. Hero Section */}
      <HeroBanner lottie={virtualreality_animation} />

      {/* 2. Tariffs Hub (CATV + Net, Fiber, Corporate) */}
      <TariffsSection />

      {/* 3. Speed Test & Interactive Bandwidth Calculator */}
      <SpeedTestSection />

      {/* 4. Coverage Interactive Map & Settlement Search */}
      <CoverageSection />

      {/* 5. Company Legacy & Infrastructure Pillars */}
      <AboutSection />

      {/* 6. Contacts Center */}
      <ContactsSection />
    </div>
  );
}
